<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Customer Medical Notes</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!inEditMode">
    <p style="white-space: pre-wrap">{{ notes.medical_notes }}</p>
  </div>

  <div class="modal-body" *ngIf="inEditMode">
    <div class="form-group">
      <label for="noteTextarea">Notes</label>
      <textarea class="form-control" id="noteTextarea" name="note" required
                [(ngModel)]="notes.medical_notes"></textarea>
      <div class="form-text text-danger">{{ errors.medical_notes }}</div>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer" *ngIf="!inEditMode">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Back
    </button>
    <button type="button" class="btn btn-primary"
            (click)="inEditMode = true">
      Edit
    </button>
  </div>

  <div class="modal-footer" *ngIf="inEditMode">
    <button type="button" class="btn btn-danger"
            *ngIf="!loadingSubmit"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSaveEdit()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
